import {
  UserRole,
  canManageKartsForWorkspace,
  canManageDriversForWorkspace,
  canManageTeamForWorkspace,
  canViewTeamMembersForWorkspace,
  isTeamWorkspaceOwner,
} from '@kangaroo/shared';

export { isTeamWorkspaceOwner };

export function canManageDrivers(role: UserRole, options?: { isTeamWorkspaceOwner?: boolean }) {
  return canManageDriversForWorkspace(role, options);
}

export function canManageTeam(role: UserRole, options?: { isTeamWorkspaceOwner?: boolean }) {
  return canManageTeamForWorkspace(role, options);
}

export function canCreateTeamWorkspace(role: UserRole) {
  return role === UserRole.TEAM_OWNER || role === UserRole.COACH || role === UserRole.PARENT;
}

export function canViewTeamMembers(role: UserRole, options?: { isTeamWorkspaceOwner?: boolean }) {
  return canViewTeamMembersForWorkspace(role, options);
}

export function canManageKarts(role: UserRole, options?: { isTeamWorkspaceOwner?: boolean }) {
  return canManageKartsForWorkspace(role, options);
}

export function canCreateTelemetrySegment(role: UserRole, options?: { isTeamWorkspaceOwner?: boolean }) {
  return canManageKarts(role, options);
}

export function canViewMaintenanceQueue(role: UserRole, options?: { isTeamWorkspaceOwner?: boolean }) {
  return canManageKarts(role, options) || role === UserRole.DRIVER || role === UserRole.PARENT;
}

export function canManageDataFiles(role: UserRole) {
  return role === UserRole.TEAM_OWNER || role === UserRole.COACH || role === UserRole.MECHANIC || role === UserRole.DRIVER || role === UserRole.PARENT;
}

export function canUpdateTelemetrySessionContext(role: UserRole) {
  return (
    role === UserRole.TEAM_OWNER ||
    role === UserRole.COACH ||
    role === UserRole.MECHANIC ||
    role === UserRole.DRIVER ||
    role === UserRole.PARENT
  );
}

export function canViewFleet(role: UserRole) {
  return canManageKarts(role) || role === UserRole.DRIVER || role === UserRole.PARENT;
}

export function isDriverRole(role: UserRole) {
  return role === UserRole.DRIVER;
}

export function isFamilyRole(role: UserRole) {
  return role === UserRole.PARENT;
}

export function canUseTracksideImport(role: UserRole) {
  return canManageDataFiles(role);
}

export function formatRoleLabel(role: UserRole) {
  return role
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function roleHomeLens(role: UserRole) {
  if (isDriverRole(role)) {
    return 'Driver lens';
  }
  if (isFamilyRole(role)) {
    return 'Parent lens';
  }
  if (role === UserRole.MECHANIC) {
    return 'Mechanic lens';
  }
  if (role === UserRole.TEAM_OWNER) {
    return 'Team owner lens';
  }
  if (role === UserRole.COACH) {
    return 'Coach lens';
  }
  return 'Team lens';
}
